var React = require('react');

function BlacktopLogoMark (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M110.696 22.139L88.557 0H66.417H22.139V22.139H66.417H88.557V44.278H110.696V22.139Z","fill":"#F0FF63","key":0}),React.createElement("path",{"d":"M22.139 44.278V22.139H0V44.278V66.417V88.557H22.139V66.417H66.417H88.557V88.557H66.417H22.139V110.696H66.417H88.557L110.696 88.557V66.417L88.557 44.278H66.417H22.139Z","fill":"#F0FF63","key":1})]);
}

BlacktopLogoMark.defaultProps = {"width":"111","height":"111","viewBox":"0 0 111 111","fill":"none"};

module.exports = BlacktopLogoMark;

BlacktopLogoMark.default = BlacktopLogoMark;
